module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgzMnYzMkgweiIvPjxwYXRoIGQ9Ik0yNC41IDEyLjhjLjIuMi4zLjUuMy44cy0uMS42LS4zLjhsLTcuNyA3LjhjLS4yLjItLjUuMy0uOC4zcy0uNi0uMS0uOC0uM2wtNy44LTcuOGMtLjItLjItLjMtLjUtLjMtLjhzLjEtLjYuMy0uOGMuMi0uMi41LS4zLjgtLjNoMTUuNWMuMyAwIC42LjEuOC4zeiIgZmlsbD0iIzUyNTI1MiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-arrow-down.svg
// module id = 7Cfw
// module chunks = 74 77